<template>
  <div>loading product ...</div>
</template>
<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      link: null,
      sku: null,
    };
  },
  created() {
    this.$store.commit("setLoading", true);
    this.link = this.$route.params.link;
    this.sku = this.$route.params.sku;
    this.$store
      .dispatch("sellerModule/fetchSellerByLink", this.link)
      .then((seller) => {
        if (seller.subscription_status == true && seller.status != false) {
          this.$store.commit("setLoading", false);
          this.$router.push({
            name: "catalog",
            params: {
              sku: this.sku,
            },
          });
        } else {
          this.$store.commit("setLoading", false);
          Swal.fire({
            icon: "error",
            title: "Sorry",
            text: "This account is expired,Kindly recharge.",
          });
          this.$router.push("/sellerlogout");
        }
      })
      .catch(() => {
        this.$store.commit("setLoading", false);
        this.$router.push("/404");
      });
  },
};
</script>
